/* eslint-disable */
import React, { FC, useEffect } from 'react'
import { classes, style, stylesheet } from 'typestyle'

/* Hooks ======================================================================================== */
import useValue from '../../__aeki__/hooks/use-value'

/* Components =================================================================================== */
import AppLayout, { MAX_WIDTH } from './layout'
import { Box } from '../../__aeki__/components/box/box.component'
import { FooterContent } from '../../components/footer'
import { EndPromote } from '../__home__/components/end-promote'
import { HeroTitle } from '../__home__/components/web-hero-title'
import { pl8 } from '../../__aeki__/styles/styleset/padding/pl8'
import { pr8 } from '../../__aeki__/styles/styleset/padding/pr8'
import { pt40 } from '../../__aeki__/styles/styleset/padding/pt40'
import { pb40 } from '../../__aeki__/styles/styleset/padding/pb40'
import { Text } from '../../__aeki__/components/text/text.component'
import { useParams } from 'react-router-dom'

const locale = {
  title: {
    en: 'Terms of Service',
    ko: '이용약관',
  },
  description: {
    en: 'Terms of Service',
    ko: '이용약관',
  },
  삼일로지스틱스: {
    en: 'Samill Logistics',
    ko: '삼일로지스틱스',
  },
  content: {
    ko: `제1조 목적

    이 약관은 삼일로지스틱스(이하"회사"라 한다)이 운영하는 samillogistics.com (이하"사이트"라 한다)에서 제공하는 문자메세지 전송 서비스(이하 "서비스"라 한다)의 이용조건 및 절차, 회사와 회원간의 권리, 의무, 기타 필요한 사항을 규정함을 목적으로 합니다.


    제2조 약관의 효력 및 변경

    1. 이 약관은 그 내용을 회사 사이트에 게시하여 이용회원에게 공지함으로써 효력을 발생합니다.
    2. 회사는 관련법을 위배하지 않는 범위에서 이 약관을 정할 수 있으며 필요시 약관을 변경할 수 있습니다.
    3. 회사가 약관을 변경할 경우에는 회사 사이트에 그 적용일자 7일 이전부터 적용일자 전일까지 공지하며, 제1항과 같은 방법으로 효력이 발생합니다.
    4. 회원은 변경된 약관 사항에 동의하지 않으면 서비스 이용을 중단하고 언제든지 탈퇴할 수 있습니다. 약관의 효력발생일 이후의 계속적인 서비스 이용은 약관의 변경사항에 동의한 것으로 간주합니다.


    제3조 약관의 적용

    1. 이 약관에서 정하지 않은 사항은 관계법규에 의하거나, 관계법규 등에도 정함이 없는 경우 일반적인 상관례에 따릅니다.


    제4조 용어의 정의

    1. 이 약관에서 사용하는 용어의 정의는 다음과 같습니다.
       ① 회원 : 본 약관에 동의하고 서비스 이용에 필요한 사용자 아이디와 사용자 비밀번호를 부여받아 회사가 운영하는 사이트에서 서비스를 이용하는 개인을 말합니다.
       ② 사용자 아이디 : 회원의 식별과 회원의 서비스 이용을 위하여 회원이 지정하는 4~12자로 구성된 문자와 숫자의 조합을 말합니다.
       ③ 사용자 비밀번호 : 회원이 부여받은 사용자 아이디와 일치되는 회원임을 확인하고 회원의 비밀보호를 위해 정한 4~12자로 구성된 문자 또는 숫자의 조합을 말합니다.





    [제2장 계약의 체결]



    제5조 가입신청

    1. 이용자는 회사가 정한 가입 양식에 따라 회원정보를 성실히 기입하고, 약관에 동의한다는 의사표시를 함으로서 회원가입을 신청하며 회사는 이를 회사가 정한 실명확인절차를 거쳐 회원가입을 승낙하는 것을 원칙으로 합니다.


    제6조 계약의 성립

    1. 서비스의 이용계약은 이용자의 가입신청과 회사의 승낙에 의하여 성립합니다.
    2. 회사는 다음 다음 각호의 1에 해당하는 이용신청에 대하여 서비스 이용승낙을 유보할 수 있습니다.
       ① 회사의 설비에 여유가 없는 경우
       ② 회사가 기술상 서비스 구현이 어려울 경우
       ③ 기타 회사의 귀책사유로 이용승낙이 곤란한 경우
    3. 회사는 다음 각호의 1에 해당하는 이용신청에 대하여는 이를 승낙하지 아니할 수 있으며 승낙후에도 사전통보없이 계약을 해지할 수 있습니다.
       ① 실명이 아닌 경우
       ② 다른 사람의 명의를 도용하여 신청한 경우
       ③ 이용신청시 필요내용을 허위로 기재하여 신청한 경우
       ④ 용자가 서비스의 정상적인 제공을 저해하거나 다른 이용자의 서비스 이용에 지장을 줄 것으로 예상되는 경우
       ⑤ 신용정보의 이용과 보호에 관한 법률에 의하여 신용불량자로 등록되어 있는 경우
       ⑥ 정보통신윤리위원회의 인터넷 서비스 불량이용자로 등록되어 있는 경우
       ⑦ 이용신청 요건이 미비되었거나 본인확인이 불가능할 경우
       ⑧ 기타 이용 신청 고객의 귀책사유로 이용승낙이 곤란한 경우


    제7조 사용자 아이디 이용 및 변경 등

    1. 회원가입 시 지정하는 사용자 아이디는 원칙적으로 변경이 불가능하며 제3자에게 이용하게 해서는 안됩니다.





    [제3장 서비스와 관련한 각 당사자의 의무]



    제8조 회사의 의무

    1. 회사는 법령과 이 약관이 금지하는 행위를 하지않으며 이 약관이 정하는 바에 따라 지속적이고, 안정적으로 서비스를 제공하는데 최선을 다해야 합니다.
    2. 회사는 회원이 안전하게 서비스를 이용할 수 있도록 회원의 개인정보를 보호, 관리하기 위해 필요한 조치를 취합니다.
    3. 회사는 이용자로부터 제기되는 의견이나 불만이 정당하다고 인정할 경우에는 즉시 처리하여야 합니다. 다만, 즉시 처리가 곤란한 경우는 이용고객에게 그 사유를 전자우편, 전화 등으로 통보하여야 합니다.
    4. 회사는 회원 개인 정보를 본인의 승낙없이 제3자에게 누설, 배포하지 않는 것을 원칙으로 합니다. 단, 다음 각 호에 해당하는 경우는 예외로 합니다.
       ① 전기통신기본법 등 법률의 규정에 의해 국가기관의 요구가 있는 경우
       ② 범죄에 대한 수사상의 목적이 있거나 정보통신윤리위원회의 요청이 있는 경우
       ③ 기타 관계법령에서 정한 절차에 따른 요청이 있는 경우


    제9조 회원의 의무

    1. 회원은 이 약관에서 규정하는 모든 사항과 서비스 이용안내 및 주의사항 등을 준수하여야 합니다.
    2. 회원은 등록 양식에서 요구되는 내용들에 대해 진실되고 정확하며 현재의 사실과 일치되는 완전한 정보를 제공하고 유지합니다.
    3. 회원은 자신의 ID와 비밀번호를 관리할 의무를 가지고 있으며, 그에 대한 회원의 관리 소홀로 인하여 발생하는 모든 결과에 대하여는 회원에게 책임이 있습니다.
    4. 회원은 자신의 ID 및 비밀번호를 제3자에게 이용하게 해서는 안되며, ID 및 비밀번호를 도난 당하거나 제3자가 사용하고 있음을 인지한 경우에는 바로 회사에 통보하고 회사의 안내가 있는 경우에는 그에 따라야 합니다.
    5. 회원은 서비스를 이용함에 있어 공공질서 또는 미풍양속을 해치는 행위, 또는 다음 각호에 해당하는 행위를 해서는 안됩니다.
       ① 다른 이용자의 이용 아이디를 부정 사용하는 행위
       ② 해킹 행위 또는 컴퓨터 바이러스의 유포행위
       ③ 타인의 의사에 반하여 광고성정보 등 유사한 내용을 지속적으로 전송하는 행위
       ④ 타인의 지적 재산권 등을 침해하는 행위
       ⑤ 범죄행위를 목적으로 하거나 범죄행위를 교사하는 행위
       ⑥ 반국가적 범죄의 수행을 목적으로 하는 행위
       ⑦ 선량한 풍속 또는 기타 사회질서를 해치는 행위
       ⑧ 서비스의 안전적인 운영이 지장을 주거나 줄 우려가 있는 일체의 행위




    [제4장 서비스의 이용, 제한, 유의사항]



    제10조 서비스의 이용

    1. 서비스 이용은 회사가 회원가입을 확인한 직후부터 가능합니다.
    2. 서비스 이용시간은 회사의 업무상 또는 기술상 특별한 지장이 없는 경우를 제외하고는 연중무휴(1일 24시간)를 원칙으로 합니다.
    다만, 시스템의 정기점검 등 회사가 정한 날이나 시간은 그러하지 아니하며 이 경우 회사는 사전 또는 사후 이를 공지합니다.


    제11조 서비스 제공의 제한 및 중지

    1. 회사는 다음 각 호의 1에 해당하는 경우 서비스 제공의 일부 또는 전부를 제한하거나 중지할 수 있습니다.
       ① 서비스용 설비의 보수, 정기점검 또는 공사로 인한 부득이한 경우
       ② 전기통신사업법에 규정된 기간통신사업자가 전기통신 서비스를 중지했을 경우
       ③ 전시, 사변, 천재지변 또는 이에 준하는 국가비상사태가 발생하거나 발생할 우려가 있는 경우
       ④ 서비스 설비의 장애 또는 서비스 이용의 폭주 등으로 서비스 이용에 지장이 있는 경우
       ⑤ 타인의 명예를 손상시키거나 불이익을 주는 행위를 한 경우
       ⑥ 서비스 이용요금을 정한 기일 내에 납입하지 아니한 경우
       ⑦ 공공질서 및 미풍양속에 저해되는 내용을 고의로 유포시킨 경우
       ⑧ 수신자의 의사에 반하여 또는 동의 없이 광고성 메시지를 지속적으로 전송하는 경우


    제12조 서비스 사용시 유의사항

    1. 문자메세지의 전송이 집중되는 경우 전송이 지연되거나 실패할 수 있습니다. 회원은 메시지 발송 후 전송결과를 확인하여야 하며 전송결과를 확인하지 않아 발생한 불이익은 회원에게 책임이 있습니다.
    2. 문자메세지의 전송성공 기준은 각 이동통신사업자의 문자메세지 전송시스템에 정상적으로 전송되는 경우로 합니다.
    3. 수신자가 서비스지역 밖이거나 서비스를 이용할 수 없는 상태에서 메시지가 수신되지 않거나, 메시지 재전송 시간(12시간)을 초과하여 시스템에 의해 삭제된 메시지에 의한 손실은 회사가 책임지지 않습니다.


    제13조 게시물의 저작권

    1. 이용자가 서비스 페이지에 게시하거나 등록한 자료의 지적재산권은 이용자에게 귀속 됩니다. 단, 회사는 서비스 홈페이지의 게재권을 가지며 회사의 서비스 내에 한하여 이용자의 게시물을 활용할 수 있습니다.
    2. 이용자는 서비스를 이용하여 얻은 정보를 가공, 판매하는 행위 등 게재된 자료를 상업적으로 이용할 수 없으며 이를 위반하여 발생하는 제반 문제에 대한 책임은 이용자에게 있습니다.
    3. 회사는 이용자 게시물의 내용 검열, 검색 및 관리에 따른 일체의 손해배상 책임을 지지 아니합니다.


    제14 조 요금 등의 반환

    1. 회사는 요금 등의 과납 또는 오납이 있을 때에는 그 과납 또는 오납된 요금을 반환하고, 회사의 귀책사유로 발생한 경우에는 법정이율로서 적정이자를 함께 반환합니다.
    2. 선납제에 한하여 이용자는 서비스를 이용하기 전 선납된 요금 등의 반환을 요청할 수 있습니다. 이러한 경우 회사는 이용자가 반환을 요청한 시점으로부터 익월 말일까지 이용자가 결제한 은행계좌로 반환요청 요금을 반환합니다.
    단, 요금반환은 반환요청 금액이 최소1만원 이상인 경우에만 가능하며 요금 반환 시 소정의 수수료를 차감할 수 있습니다.
    3. 핸드폰과 신용카드 결제인 경우 결제후 요금을 납부하신 후에 환불이 가능하며 미납상태에서는 환불이 불가능합니다.
    4. 회사는 환불신청이유를 심사한 후, 환불신청 이유에 따라 회원에게 이용료 상당의 발송 건수를 회원의 계정에 재충전 방법으로 환불하여 드리거나 약관에 따라 산정된 금액으로 고객의 계좌에 현금입금의 방법으로 환불하여 드릴 수 있습니다.
    5. 고객의 환불신청시 구매 후 이용하고 남은 발송 건수 잔액에서 재정경제부에서 고시한 [인터넷이용관련소비자피해보상]상 규정한 위약금(총이용료의 20%) 및 PG수수료, 송금비용을 공제한 이용료 잔액을 환불하여 드립니다




    [제5장 손해배상 및 면책]



    제15조 손해배상

    1. 회사의 귀책사유로 회원이 서비스를 이용하지 못하는 경우에는 회사가 회원에게 손해를 배상합니다.
    2. 손해 배상의 방법, 절차 등은 관계법령에 따릅니다.
    3. 회원이 약관을 위반하거나 관계 법령을 위반하여 제3자 또는 회사에 손해가 발생할 시에는, 회원은 회사나 제3자에게 발생한 손해를 배상할 책임이 있습니다.


    제16조 면책

    1. 회사는 그 손해가 천재지변 또는 이에 준하는 불가항력이거나 고객의 고의 또는 과실로 인하여 발생한 경우 손해배상에 관한 책임이 면제됩니다.
    2. 회사는 이용자가 게시 또는 전송한 자료의 내용에 대하여는 책임을 면합니다.
    3. 회사는 무료로 제공하는 서비스에 대하여 회사의 귀책 사유로 이용자에게 서비스를 제공하지 못하는 경우 책임을 면합니다.


    제17조 (분쟁조정)

    1. 회사와 이용자는 개인정보에 관한 분쟁이 있을 경우 신속하고 효과적인 분쟁해결을 위하여 한국정보보호센터 내의 개인정보분쟁조정위원회에 그 처리를 의뢰할 수 있습니다.
    2. 요금 등 서비스 이용으로 발생한 분쟁에 대해 소송이 제기될 경우 회사의 본사 소재지 법원을 관할법원으로 합니다.`,
    en: `Article 1: Purpose

This agreement is intended to stipulate the terms and procedures for using the text message sending service (hereinafter referred to as the "Service") provided on samillsp.com (hereinafter referred to as the "Site") operated by Samil Logistics (hereinafter referred to as the "Company"), as well as the rights, obligations, and other necessary matters between the Company and the members.

Article 2: Effect and Modification of the Agreement

This agreement takes effect by posting its content on the Company's website and notifying the members.
The Company may establish and modify this agreement within the scope not violating relevant laws.
If the Company changes this agreement, it will be notified on the Company's website from 7 days before the effective date to the day before the effective date, and it will take effect in the same way as in paragraph 1.
If a member does not agree to the changed terms, the member can stop using the service and withdraw at any time. Continuous use of the service after the effective date of the agreement is considered as an agreement to the changes in the terms.
Article 3: Application of the Agreement

Matters not specified in this agreement shall be governed by general customs, unless otherwise stipulated by relevant laws and regulations or unless otherwise specified by relevant laws and regulations.

Article 4: Definitions

The definitions of terms used in this agreement are as follows:
① Member: An individual who agrees to this agreement, receives a user ID and user password necessary for using the service, and uses the service on the website operated by the Company.
② User ID: A combination of 4 to 12 characters, including letters and numbers, designated by the member for identification and use of the member's service.
③ User Password: A combination of 4 to 12 characters or numbers designated by the member, matching the user ID assigned to the member for confirmation of the member's identity and protection of the member's privacy.
[Chapter 2: Conclusion of the Agreement]

Article 5: Application for Membership

Users apply for membership by accurately filling out the member information according to the membership application form specified by the Company and expressing their consent to this agreement. The Company generally accepts membership after verifying it through the real-name verification procedure specified by the Company.

Article 6: Conclusion of the Agreement

The service usage agreement is concluded based on the user's application for membership and the Company's approval.
The Company may withhold the approval of service use for the following cases:
① When there is no available equipment in the Company's facility
② When it is difficult to implement the service for technical reasons
③ When it is difficult for the Company to approve the use due to the Company's own reasons
The Company may refuse to approve the following applications, and even after approval, may terminate the contract without prior notice:
① If the information is not real
② If it is applied using someone else's name
③ If false information is provided when applying for use
④ If the user's actions are expected to hinder the normal provision of services or interfere with the use of other users
⑤ If the user is registered as a bad credit user under the Act on the Use and Protection of Credit Information
⑥ If the user is registered as a bad internet service user by the Korea Internet Ethics Committee
⑦ If the application requirements are insufficient or personal verification is impossible
⑧ In other cases where the user's application for use is difficult to approve due to the user's reasons
Article 7: Use and Change of User ID

The user ID designated at the time of membership registration is generally not changeable, and it should not be allowed to be used by a third party.

[Chapter 3: Obligations of Each Party Concerning the Service]

Article 8: Company's Obligations

The Company must do its best to continuously and stably provide the service according to this agreement and in accordance with the relevant laws and this agreement without engaging in any act prohibited by the relevant laws and this agreement.
The Company shall take measures necessary to protect and manage the personal information of members to ensure that members can use the service safely.
If opinions or complaints raised by users are deemed reasonable, the Company shall immediately handle them. However, if immediate handling is difficult, the reasons shall be notified to the user by e-mail, phone, etc., as appropriate.
The Company, as a rule, does not disclose or distribute members' personal information to third parties without the members' consent. However, exceptions are made in the following cases:
① When required by the Act on Telecommunications Basic Act or other laws
② In case of a request from the Information and Communication Ethics Committee for the purpose of investigation
③ In other cases where requests are made according to the procedures prescribed by other related laws

Article 9: Member's Obligations

Members must comply with all matters specified in this agreement, service usage instructions, and cautions.
Members must provide truthful, accurate, and current information for the content required in the registration form and keep it up to date.
Members have the obligation to manage their own ID and password, and they are responsible for all consequences that occur due to the member's negligence in managing them.
Members should not allow third parties to use their ID and password. In case of theft or awareness of unauthorized use of the ID and password by a third party, the member must immediately notify the Company and follow the Company's instructions.
Members must not engage in the following acts when using the service:
① Unauthorized use of another user's ID
② Hacking or spreading computer viruses
③ Continuously sending advertisements or similar content to the detriment of others' will
④ Infringement of others' intellectual property rights
⑤ Engaging in or teaching criminal activities or actions aimed at performing anti-national crimes
⑥ Actions aimed at performing anti-national crimes
⑦ Actions that damage public morals or disrupt social order
⑧ Any acts that may interfere with the safe operation of the service or cause concerns.

[Chapter 4: Use, Restriction, and Precautions of the Service]

Article 10: Use of the Service

Service usage is possible from the moment the Company confirms membership registration.
The service usage time is generally 24 hours a day, 7 days a week, unless there are special disruptions in the Company's business or technical operations. However, the Company will notify users in advance or post-notice if regular inspections or other specified days and times are excluded.

Article 11: Limitation and Suspension of Service Provision

The Company may restrict or suspend the provision of all or part of the service in the following cases:
① Maintenance, regular inspection, or construction of service equipment
② When the telecommunications service provider specified in the Telecommunications Business Act has suspended the telecommunications service
③ In case of national emergency situations such as war, insurrection, natural disasters, or other events equivalent thereto, or when there is an anticipation of such occurrences
④ When there is a service equipment failure or a surge in service usage that hinders service provision
⑤ If the user engages in actions that damage others' reputation, cause harm, send continuous advertisements without the consent of the recipient, infringe on intellectual property rights, commit crimes, engage in actions aimed at performing anti-national crimes, disrupt public order and morals, or engage in any actions that may interfere with the safe operation of the service.

Article 12: Precautions when Using the Service

If text messages are concentrated during transmission, there may be delays or failures in transmission. Users must check the transmission results after sending messages, and any disadvantages resulting from not checking the transmission results are the responsibility of the user.
The standard for the success of sending text messages is when they are successfully sent through the normal transmission system of each mobile communication service provider.
If the recipient is outside the service area or unable to use the service, messages may not be received, or losses due to messages deleted by the system after exceeding the message resend time (12 hours) will not be the responsibility of the Company.

Article 13: Copyright of Postings

Intellectual property rights of materials posted or registered by users on the service page belong to the user. However, the Company has the posting rights on the service homepage and can utilize user postings within the scope of the service.
Users may not commercially use posted materials, such as processing and selling information obtained through the service. Users are responsible for all issues arising from the violation of this provision.
The Company is not responsible for any damages related to the censorship, search, and management of user postings.

Article 14: Compensation for Damages

If a member is unable to use the service due to the Company's fault, the Company shall compensate the member for damages.
The method, procedure, etc., for compensation for damages shall be in accordance with the relevant laws.
If a member violates this agreement or violates related laws, resulting in damages to a third party or the Company, the member shall be responsible for compensating the Company or the third party for the damages.

Article 15: Exemption

The Company shall be exempt from liability for damages when the damages are due to force majeure or equivalent events, the user's intent or negligence.
The Company shall be exempt from liability for the content of materials posted or transmitted by users.
The Company shall be exempt from liability for the provision of services to users for free due to the Company's fault.

Article 16: (Dispute Resolution)

In case of a dispute regarding personal information between the Company and a user, the user may request the Korean Information Protection Center's Personal Information Dispute Mediation Committee for a quick and effective dispute resolution.
In the event of a lawsuit arising from fees or other service usage, the court located at the Company's headquarters shall have jurisdiction.

    `,
  },
}

const Agreement: FC<any> = (props: any) => {
  const { inject, eject } = props
  const injection = inject()

  const [loaded, $loaded] = useValue(false)
  const { loc = 'ko' } = useParams<{ loc: 'en' | 'ko' }>()

  useEffect(() => {
    setTimeout(() => {
      $loaded.set(true)
    }, 300)

    return () => {
      eject()
    }
  }, [])

  return (
    <AppLayout.render
      head={{
        title: `${locale.title[loc]} - ${loc === 'ko' ? '삼일로지스틱스' : 'Samil Logistics'}`,
        description: locale.description[loc],
        mainImage: process.env.REACT_APP_PROJECT_MAIN_IMAGE,
      }}
      content={
        <Box className={STYLES.container} baseline="surface" row flex>
          <Box
            className={style({
              overflow: 'hidden',
              marginTop: -160,
              height: '50vh',
              background:
                'linear-gradient(180deg, rgba(37,76,59,1) 0%, rgba(36,88,65,1) 43%, rgba(69,126,98,1) 100%)',
            })}
            relative
            fullWidth
            shadow
            baseline="primary"
            alt
          >
            <HeroTitle
              textUpper={locale.삼일로지스틱스[loc]}
              textLower={locale.title[loc]}
              textLarge={false}
            />
          </Box>

          <Box
            baseline="none"
            className={classes(pl8, pr8, pt40, pb40)}
            maxWidth={800}
            fullWidth
            centerAutoX
            row
          >
            <Box
              style={{
                whiteSpace: 'pre-wrap',
              }}
            >
              <Text size="sm">{locale.content[loc]}</Text>
            </Box>
          </Box>
          <EndPromote
            title={'종합물류서비스'}
            subtitle={'삼일로지스틱스가 제공하는 차별화된 물류서비스에 대해 알아보세요.'}
            link={'/a/services'}
          />
          <Box className={STYLES.containerFooter} baseline="background">
            <FooterContent />
          </Box>
        </Box>
      }
    />
  )
}

/* Styles ======================================================================================= */
const STYLES = stylesheet({
  container: {
    width: '100%',
  },
  containerInner: {
    maxWidth: MAX_WIDTH,
    padding: '60px 8px',
    margin: '0 auto',
  },
  containerFooter: {
    padding: '40px 4px 12px 4px',
  },
  textInitial: {
    transform: 'translateY(16px)',
    opacity: 0,
  },
  textVisible: {
    transition: 'all 0.2s ease-in-out',
    transitionProperty: 'transform',
    // transitionDelay: '2s',
    opacity: 1,
    transform: 'translateY(0px)',
  },
})

export default Agreement
